import React from "react";

import classNames from "classnames";
import { Field } from "formik";
import { FormattedMessage, useIntl } from "gatsby-plugin-react-intl";
import PropTypes from "prop-types";
import Form from "react-bootstrap/Form";

import { ReactComponent as IconError18 } from "../../../icons/icon/18/a-icon-error-18.svg";
import InputSelect from "../../inputSelect/inputSelect";

const DropdownFormField = ({
  errors,
  id,
  label,
  meta = null,
  onBlur,
  onChange,
  options,
  otherSelected = () => {},
  placeholder = undefined,
  setFieldValue = () => {},
  touched,
  values = null,
}) => {
  const intl = useIntl();

  const reactSelectOptions = options ? options.map((e) => (e && typeof e === "object" ? {
    label: e.label,
    value: e.value,
  } : { label: e, value: e })) : [];

  const getOptionByValue = (items, value) => items.find((el) => el.value === value);

  return (
    <Field
      name={id}
    >
      {() => (
        <Form.Group
          className={classNames(
            {
              required: meta.requiredFields.includes(id),
            },
          )}
        >
          <InputSelect
            label={label}
            placeholder={placeholder || intl.formatMessage({ id: "form.please_select" })}
            inputId={id}
            name={id}
            items={reactSelectOptions}
            value={getOptionByValue(reactSelectOptions, values?.[id])}
            onChange={(selectedOption) => {
              onChange({
                target: {
                  id,
                  name: id,
                  type: "",
                  value: selectedOption?.value || "",
                },
              });

              if (typeof otherSelected === "function") {
                otherSelected(selectedOption?.value || "", setFieldValue);
              }
            }}
            onBlur={onBlur}
            isInvalid={(errors[id] && touched[id])}
          />
          <Form.Label>
            {label}
          </Form.Label>
          <Form.Text
            className={classNames({ "invalid-feedback": (errors[id] && touched[id]) })}
          >
            {errors[id] && touched[id]
              ? <div><IconError18 />{errors[id]}</div>
              : <>{!meta.requiredFields.includes(id) && <FormattedMessage id="form.optional" />}</>}
          </Form.Text>
        </Form.Group>
      )}
    </Field>
  );
};

DropdownFormField.propTypes = {
  errors: PropTypes.oneOfType([PropTypes.object]).isRequired,
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  meta: PropTypes.oneOfType([PropTypes.object]),
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.oneOfType([PropTypes.array]).isRequired,
  otherSelected: PropTypes.func,
  placeholder: PropTypes.string,
  setFieldValue: PropTypes.func,
  touched: PropTypes.oneOfType([PropTypes.object]).isRequired,
  values: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
};

export default DropdownFormField;
